import { Pipe, PipeTransform } from '@angular/core';

/**
 * @author Fred
 *
 * Level Access raised an issue about the language codes,
 * saying that the last two letters that represent the region subtag should be capitalized otherwise,
 * screen readers will use inappropriate pronunciation when announcing this text.
 */

@Pipe({
  name: 'a11yLangAttribute',
  standalone: true,
})
export class A11yLangAttributePipe implements PipeTransform {
  transform(value: string): string {
    return this._capitalizeLastTwoLetters(value);
  }

  private _capitalizeLastTwoLetters(str: string): string {
    // Regex pattern to match a hyphen followed by exactly two alphabetic characters at the end
    const regex = /-(\w{2})$/;

    // Replace the matched last two letters with their uppercase equivalent
    return str.replace(regex, (match, p1) => `-${p1.toUpperCase()}`);
  }
}
